import { getTypedState } from 'ducks/hooks'
import { PropertyActivity } from 'ducks/types'

export const getPropertyActivity = () => (): PropertyActivity => {
  const { propertyActivity } = getTypedState()
  return propertyActivity
}
